import React, {FC, useEffect} from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/app/providers/StoreProvider';
import { MyTeamItem } from './MyTeamItem';
import { MyTeamEmpty } from './MyTeamEmpty';
import {Loading} from "@/shared/ui/Loading";



interface MyTeamProps{
  searchClick: () => void;
}

export const MyTeam:FC<MyTeamProps> = observer(({searchClick}) => {

  const {teamStore} = useStore();
  const {myTeam, myTeamLoaded, loadingTeams} = teamStore;

    useEffect(() => {
        if(!myTeamLoaded){
            teamStore.getMyTeam();
        }
    }, []);
    if (loadingTeams) return <Loading/>
  return (
    <div className='myTeam'>
      {
        myTeam
        ? <MyTeamItem team={myTeam}/>
        : <MyTeamEmpty searchClick={searchClick}/>
      }
    </div>
  );

});
